module.exports = __webpack_public_path__ + "img/lightNode.153a933d.svg";